// Menu sub-categories per shop page. Products match by name keywords (Shopify product types are empty).
export const SUBCATEGORIES = {
  skincare: [
    { label: "Cleansers", match: ["cleanser", "cleansing", "face wash", "facial wash", "mousse", "foam", "micellar", "make-up remover", "oil-to-milk"] },
    { label: "Serums", match: ["serum", "booster", "concentrate"] },
    { label: "Moisturizers", match: ["moisturi", "cream", "hydrating gel", "face gel", "gel-cream"], exclude: ["eye"] },
    { label: "Eye Care", match: ["eye"] },
    { label: "Face Oils", match: ["face oil", "facial oil", "beard oil"] },
    { label: "Masks", match: ["mask", "patches"] },
    { label: "Toners & Mists", match: ["toner", "mist"] },
    { label: "Exfoliators", match: ["exfoliat", "peeling"] },
    { label: "SPF", match: ["spf", "sunscreen"] },
  ],
  body: [
    { label: "Body Oils & Serums", match: ["body oil", "body serum"] },
    { label: "Lotions & Creams", match: ["lotion", "body cream", "tallow cream", "recovery cream", "shea butter"] },
    { label: "Scrubs", match: ["scrub", "exfoliat", "luffa", "mud"] },
    { label: "Bath & Soap", match: ["bath", "soap", "body wash", "foaming wash", "cleanser"] },
    { label: "Hand Care", match: ["hand"] },
    { label: "Deodorant", match: ["deodorant"] },
  ],
  hair: [
    { label: "Shampoo", match: ["shampoo"] },
    { label: "Conditioner", match: ["conditioner"] },
    { label: "Hair Oils", match: ["oil"] },
    { label: "Treatments", match: ["mask", "serum", "treatment"] },
    { label: "Styling", match: ["mist", "spray"] },
    { label: "Scalp Care", match: ["scalp"] },
  ],
  makeup: [
    { label: "Foundation", match: ["foundation"] },
    { label: "Concealer", match: ["concealer", "correcting"] },
    { label: "Blush", match: ["blush"] },
    { label: "Lipstick", match: ["lip"] },
    { label: "Mascara", match: ["mascara"] },
    { label: "Brows", match: ["brow"] },
    { label: "Setting Spray", match: ["setting"] },
  ],
  fragrance: [
    { label: "Eau de Parfum", match: ["parfum"] },
    { label: "Eau de Toilette", match: ["toilette"] },
    { label: "Body Mists", match: ["mist"] },
    { label: "Candles", match: ["candle"] },
    { label: "Discovery Sets", match: ["discovery"] },
  ],
  "beauty-tools": [
    { label: "Gua Sha & Rollers", match: ["gua sha", "roller"] },
    { label: "Makeup Brushes", match: ["brush"] },
    { label: "Sponges & Applicators", match: ["sponge", "applicator"] },
    { label: "Hair Tools", match: ["comb", "hair tool", "dryer"] },
    { label: "Mirrors", match: ["mirror"] },
    { label: "Bags & Cases", match: ["bag", "case"] },
  ],
};

export const matchesSub = (product, sub) => {
  const name = (product.name || "").toLowerCase();
  if (sub.exclude?.some((w) => name.includes(w))) return false;
  return sub.match.some((w) => name.includes(w));
};

export const findSub = (slug, label) => SUBCATEGORIES[slug]?.find((s) => s.label === label) || null;

export const subHref = (slug, label) => `/shop/${slug}?sub=${encodeURIComponent(label)}`;

export const subCounts = (slug, products = []) =>
  (SUBCATEGORIES[slug] || []).map((sub) => ({ ...sub, count: products.filter((p) => matchesSub(p, sub)).length }));
